import { useContext } from "react"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import UserContext from "../Context/UserContext"
import { resetPassword } from "../Requests/firebaseAuth"

export default function ResetPassword(){
  const [newPassword, setNewPassword] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  const useQuery = ()=>{
    return new URLSearchParams(location.search)
  }

  const query = useQuery()


  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    const res = await resetPassword(query.get('oobCode'), newPassword)
    if(res.status === 'success'){
      navigate(`/signin`)
    }else{
      switch (res.error.code) {
        case 'auth/weak-password':
          setError('La contraseña debe tener más de 6 caracteres')
          break;
        default:
          setError('No se pudo cambiar la contraseña, intente de nuevo más tarde')
          break;
      }
    }
    
  }

  return <div className="container mx-auto px-4">
          <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
      <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center mt-4">
      <h1 className="text-xl">Cambiar contraseña</h1>
      <form onSubmit={handleSubmit} className='flex flex-col gap-4 w-full my-4'>
        <div className="input-holder w-[75%]">
          <input type="password" name='password' id='new-password' value={newPassword} onChange={(e)=>{setNewPassword(e.target.value)}} required/>
          <label htmlFor="new-password">Nueva contraseña</label>
        </div>
        {error!==''?
      <div className="w-[75%] py-2 px-3 border rounded-[10px] border-[#EE2325] text-[#EE2325] text-center mx-auto mb-4">
        <span>{error}</span>
      </div>:<></>}
        <button className="send-btn">Aceptar</button>
      </form>
    </div>
  </div>
}